export const TER01_01 = {
  selectedValueColumn: "ItemCode",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Customers",
        binding: {
          data: {
            columns: [
              {
                name: "Session No.",
                columnName: "SessionNumber",
                width: "150px",
                align: "left",
                sortable: false,
              },
              {
                name: "Account Name",
                columnName: "AccountName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "Account Address",
                columnName: "AccountAddress",
                width: "500px",
                align: "left",
                sortable: true,
              },
            ],
            title: "Customers",
            endpoint: "TER01.1",
            parameters: [
              { key: "FromMonth", value: "CP1" },
              { key: "FromYear", value: "2026" },
              { key: "ToMonth", value: "CP1" },
              { key: "ToYear", value: "2026" },
              { key: "TradeTeamCode", value: "" },
              { key: "ItemCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: {},
            },
          },
        },
      },
    },
  ],
};
